import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiService } from 'src/app/core/helpers/apiClient';
import { NgxSpinnerService } from 'ngx-spinner';

import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import appSettings from '../../../assets/settings/system.settings.json'
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ConfigService } from "src/app/core/services/getSettings";


@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangePasswordComponent {
  protected appSettings = ConfigService.settings;

  changePassword: FormGroup;
  formDataSubmit: boolean = false;
  @Input() token;

  constructor(
    private apiServices: ApiService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private authSer: AuthenticationService) {

    this.buildForm();
  }

  buildForm() {
    this.changePassword = this.formBuilder.group({
      currentPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required, Validators.pattern("^(?=.*[A-Za-z])(?=.*\\d)(?=.*[.~@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,}")]],
      confirmPassword: [null, [Validators.required]]
    });
  }
  get f() { return this.changePassword.controls }

  resetForm() {
    this.changePassword.reset();
  }

  onSubmit() {
    this.formDataSubmit = true;
    if (!this.changePassword.valid) {
      return;
    }
    var data = this.changePassword.controls;

    if (data.newPassword.value !== data.confirmPassword.value) {
      this.changePassword.controls["confirmPassword"].setErrors({ confirmedValidator: true });
      return;
    }
    this.spinner.show();
    var obj = {
      currentPassword: data.currentPassword.value,
      newpassword: data.newPassword.value,
      confirmedPassword: data.confirmPassword.value
    }
    var apiPath = `${this.appSettings.apiPath.users}/api/user/changepassword`
    this.apiServices.postExtToken(apiPath, JSON.stringify(obj), this.token).then(() => {
      this.modalService.dismissAll();
      this.spinner.hide();
      this.alertSuccess();
    }).catch(error => {
      this.spinner.hide();
      Swal.fire("ERROR!", error.error, "error");
    })
  }

  alertSuccess() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Update Success',
        html: '<span>Password Update Success</span><br /><span>Please login again with new password</span>',
        confirmButtonText: 'OK',
        allowOutsideClick: false
      })
      .then(result => {
        this.authSer.logout();
        location.reload();
      });
  }
}
